import React, { useState } from 'react';
import { CheckCircle2, Star, Lock, Zap, ShieldCheck, X, Gift, ArrowUpCircle } from 'lucide-react';
type PlanKey = 'esencial' | 'completo';
const plans = {
  esencial: {
    name: 'Plan Esencial',
    subtitle: '4 Tomos + 1 Bono',
    oldPrice: '$47.000',
    price: '$18.990',
    buttonText: '👉 Quiero empezar con el plan Esencial',
    checkoutUrl: 'https://checkout.empezahoy.shop/cart/48156290285800:1',
    badge: null,
    savings: null
  },
  completo: {
    name: 'Sistema Completo',
    subtitle: '5 Tomos + 3 Bonos completos',
    oldPrice: '$89.000',
    price: '$23.990',
    buttonText: '👉 Sí, quiero el Sistema PRO',
    checkoutUrl: 'https://checkout.empezahoy.shop/cart/48156275507432:1',
    badge: '⭐ MÁS ELEGIDO',
    savings: 'AHORRÁS $65.010'
  }
};
const esencialIncludes = ['Tomo 1 — Ficha de Primera Consulta', 'Tomo 2 — Anamnesis Podológica Completa', 'Tomo 3 — Evaluación Clínica del Pie', 'Tomo 4 — Registro de Evolución por Sesión', 'Bono 1 — Kit Consultorio PRO en 30 Min (gratis hoy)'];
const completoExtra = ['Tomo 5 — Consentimiento Informado completo con documentación legal lista para firmar', 'Bono 2 — Scripts de WhatsApp PRO con 25 mensajes listos para enviar', 'Bono 3 — Informe de Derivación Médica PRO con 9 plantillas editables', 'Acceso de por vida + actualizaciones gratuitas'];
function CheckboxIcon({
  checked
}: {
  checked: boolean;
}) {
  return <div className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors ${checked ? 'bg-amber-500 border-amber-500' : 'border-slate-300 bg-white'}`} data-id="element-124">
      {checked && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-125">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-126" />
        </svg>}
    </div>;
}
export function PricingSection() {
  const [selected, setSelected] = useState<PlanKey>('completo');
  // Completo popup state
  const [showCompletoUpsell, setShowCompletoUpsell] = useState(false);
  const [completoAddOn, setCompletoAddOn] = useState(false);
  // Esencial popup state
  const [showEsencialUpsell, setShowEsencialUpsell] = useState(false);
  const [esencialUpgrade, setEsencialUpgrade] = useState(false);
  const [esencialAddOn, setEsencialAddOn] = useState(false);
  const currentPlan = plans[selected];
  const handleBuyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (selected === 'completo') {
      setCompletoAddOn(false);
      setShowCompletoUpsell(true);
    } else {
      setEsencialUpgrade(false);
      setEsencialAddOn(false);
      setShowEsencialUpsell(true);
    }
  };
  // Completo popup URL
  const completoCheckoutUrl = completoAddOn ? 'https://checkout.empezahoy.shop/cart/48156357492968:1' : 'https://checkout.empezahoy.shop/cart/48156275507432:1';
  // Esencial popup URL logic
  const getEsencialCheckoutUrl = () => {
    if (esencialUpgrade && esencialAddOn) {
      return 'https://checkout.empezahoy.shop/cart/48156357492968:1';
    }
    if (esencialUpgrade) {
      return 'https://checkout.empezahoy.shop/cart/48156275507432:1';
    }
    if (esencialAddOn) {
      return 'https://checkout.empezahoy.shop/cart/48156608921832:1';
    }
    return 'https://checkout.empezahoy.shop/cart/48156290285800:1';
  };
  // Esencial popup total calculation
  const getEsencialTotal = () => {
    let total = 18990;
    if (esencialUpgrade) total += 5000;
    if (esencialAddOn) total += 6000;
    return `$${total.toLocaleString('es-AR')}`;
  };
  return <section className="py-16 bg-[#e8edf2]" id="comprar" data-id="element-127">
      <div className="max-w-2xl mx-auto px-4 sm:px-6" data-id="element-128">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-129">
          <h2 className="text-4xl md:text-5xl font-black text-slate-800 mb-3" data-id="element-130">
            Elegí tu plan
          </h2>
          <p className="text-lg text-slate-500" data-id="element-131">
            Acceso inmediato y de por vida. Pago único, sin suscripciones.
          </p>
        </div>

        {/* Plan Options */}
        <div className="space-y-4 mb-8" data-id="element-132">
          {(Object.keys(plans) as PlanKey[]).map(key => {
          const plan = plans[key];
          const isSelected = selected === key;
          return <button key={key} onClick={() => setSelected(key)} className={`w-full text-left rounded-2xl p-5 md:p-6 transition-all duration-200 border-2 bg-white ${isSelected ? 'border-[#4a6fa5] shadow-lg shadow-[#4a6fa5]/10' : 'border-transparent shadow-sm hover:shadow-md'}`} data-id="element-133">
                {(plan.badge || plan.savings) && <div className="flex items-center gap-2 mb-2" data-id="element-134">
                    {plan.badge && <span className="bg-[#4a6fa5] text-white text-xs font-bold px-3 py-1 rounded-md uppercase tracking-wide" data-id="element-135">
                        {plan.badge}
                      </span>}
                    {plan.savings && <span className="bg-slate-100 text-slate-600 text-xs font-bold px-3 py-1 rounded-md uppercase tracking-wide" data-id="element-136">
                        {plan.savings}
                      </span>}
                  </div>}
                <div className="flex items-center justify-between gap-4" data-id="element-137">
                  <div className="flex items-center gap-3" data-id="element-138">
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isSelected ? 'border-[#4a6fa5] bg-[#4a6fa5]' : 'border-slate-300 bg-white'}`} data-id="element-139">
                      {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-140"></div>}
                    </div>
                    <div data-id="element-141">
                      <h3 className="text-xl md:text-2xl font-bold text-slate-800" data-id="element-142">
                        {plan.name}
                      </h3>
                      <p className="text-sm text-slate-500" data-id="element-143">{plan.subtitle}</p>
                    </div>
                  </div>
                  <div className="text-right flex-shrink-0" data-id="element-144">
                    <p className="text-sm text-slate-400 line-through" data-id="element-145">
                      {plan.oldPrice}
                    </p>
                    <p className="text-3xl md:text-4xl font-black text-[#4a6fa5]" data-id="element-146">
                      {plan.price}
                    </p>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={currentPlan.checkoutUrl} onClick={handleBuyClick} className="block w-full bg-[#4a6fa5] hover:bg-[#3d5d8a] text-white text-center font-black text-lg md:text-xl py-5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5 mb-8" data-id="element-147">
          {currentPlan.buttonText}
        </a>

        {/* Plan Details Card */}
        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm mb-6" data-id="element-148">
          <h3 className="text-xl font-bold text-slate-800 mb-4 pb-4 border-b border-slate-100" data-id="element-149">
            {selected === 'esencial' ? '¿Qué incluye el Plan Esencial?' : '¿Qué incluye el Sistema Completo?'}
          </h3>
          {selected === 'completo' && <p className="text-base font-bold text-slate-700 mb-4 flex items-center gap-2" data-id="element-150">
              <span className="text-amber-500" data-id="element-151">✨</span> Todo lo del Plan
              Esencial +
            </p>}
          <ul className="space-y-3" data-id="element-152">
            {selected === 'esencial' ? esencialIncludes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-153">
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-154" />
                    <span className="text-slate-600" data-id="element-155">{item}</span>
                  </li>) : completoExtra.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-156">
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-157" />
                    <span className="text-slate-600" data-id="element-158">{item}</span>
                  </li>)}
          </ul>
          {selected === 'completo' && <p className="text-sm text-[#4a6fa5] font-medium italic text-center mt-6" data-id="element-159">
              La opción más elegida por podólogos argentinos que quieren el
              sistema completo.
            </p>}
        </div>

        {/* Trust Badges */}
        <div className="bg-white rounded-2xl py-4 px-6 flex flex-wrap justify-center gap-6 text-sm font-semibold text-slate-500 shadow-sm" data-id="element-160">
          <div className="flex items-center gap-2" data-id="element-161">
            <Lock className="w-4 h-4 text-[#4a6fa5]" data-id="element-162" />
            <span data-id="element-163">Pago seguro</span>
          </div>
          <span className="text-slate-200" data-id="element-164">•</span>
          <div className="flex items-center gap-2" data-id="element-165">
            <Zap className="w-4 h-4 text-[#4a6fa5]" data-id="element-166" />
            <span data-id="element-167">Acceso inmediato</span>
          </div>
          <span className="text-slate-200" data-id="element-168">•</span>
          <div className="flex items-center gap-2" data-id="element-169">
            <ShieldCheck className="w-4 h-4 text-[#4a6fa5]" data-id="element-170" />
            <span data-id="element-171">Garantía 7 días</span>
          </div>
        </div>
      </div>

      {/* ===== ESENCIAL UPSELL POPUP ===== */}
      {showEsencialUpsell && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-172">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowEsencialUpsell(false)} data-id="element-173"></div>
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 md:p-8 z-10" data-id="element-174">
            <button onClick={() => setShowEsencialUpsell(false)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-175">
              <X className="w-5 h-5" data-id="element-176" />
            </button>

            <div className="text-center mb-6" data-id="element-177">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-100 rounded-full mb-3" data-id="element-178">
                <Gift className="w-6 h-6 text-amber-600" data-id="element-179" />
              </div>
              <h3 className="text-xl font-black text-slate-800 mb-1" data-id="element-180">
                ¡Mejorá tu compra!
              </h3>
              <p className="text-sm text-slate-500" data-id="element-181">
                Aprovechá estas ofertas exclusivas
              </p>
            </div>

            {/* Option 1: Upgrade to Sistema Completo */}
            <button onClick={() => setEsencialUpgrade(!esencialUpgrade)} className={`w-full text-left rounded-xl p-4 border-2 transition-all duration-200 mb-3 ${esencialUpgrade ? 'border-[#0D7377] bg-teal-50 shadow-md' : 'border-slate-200 bg-slate-50 hover:border-slate-300'}`} data-id="element-182">
              <div className="flex items-start gap-3" data-id="element-183">
                <CheckboxIcon checked={esencialUpgrade} data-id="element-184" />
                <div className="flex-grow" data-id="element-185">
                  <p className="font-bold text-slate-800 text-sm mb-1" data-id="element-186">
                    ⭐ Llevate el Sistema Completo
                  </p>
                  <p className="text-xs text-slate-500 mb-2" data-id="element-187">
                    Incluye Tomo 5 (Consentimiento Informado) + Scripts de
                    WhatsApp + Informe de Derivación Médica
                  </p>
                  <p className="text-lg font-black text-[#0D7377]" data-id="element-188">
                    + $5.000{' '}
                    <span className="text-xs font-medium text-slate-400" data-id="element-189">
                      ARS
                    </span>
                  </p>
                </div>
              </div>
            </button>

            {/* Option 2: Add-on Tarjetas + Kit */}
            <button onClick={() => setEsencialAddOn(!esencialAddOn)} className={`w-full text-left rounded-xl p-4 border-2 transition-all duration-200 mb-6 ${esencialAddOn ? 'border-amber-500 bg-amber-50 shadow-md' : 'border-slate-200 bg-slate-50 hover:border-slate-300'}`} data-id="element-190">
              <div className="flex items-start gap-3" data-id="element-191">
                <CheckboxIcon checked={esencialAddOn} data-id="element-192" />
                <div className="flex-grow" data-id="element-193">
                  <p className="font-bold text-slate-800 text-sm mb-1" data-id="element-194">
                    📋 Tarjetas de Cuidados para Pacientes + 💰 Kit de Precios y
                    Paquetes PRO
                  </p>
                  <p className="text-xs text-slate-500 mb-2" data-id="element-195">
                    Material imprimible para pacientes y plantillas de precios
                    para tu consultorio.
                  </p>
                  <p className="text-lg font-black text-amber-600" data-id="element-196">
                    + $6.000{' '}
                    <span className="text-xs font-medium text-slate-400" data-id="element-197">
                      ARS
                    </span>
                  </p>
                </div>
              </div>
            </button>

            {/* Summary */}
            <div className="bg-slate-50 rounded-xl p-4 mb-6" data-id="element-198">
              <div className="flex justify-between items-center text-sm text-slate-600 mb-1" data-id="element-199">
                <span data-id="element-200">Plan Esencial</span>
                <span className="font-bold" data-id="element-201">$18.990</span>
              </div>
              {esencialUpgrade && <div className="flex justify-between items-center text-sm text-[#0D7377] mb-1" data-id="element-202">
                  <span data-id="element-203">Upgrade Sistema Completo</span>
                  <span className="font-bold" data-id="element-204">+ $5.000</span>
                </div>}
              {esencialAddOn && <div className="flex justify-between items-center text-sm text-amber-600 mb-1" data-id="element-205">
                  <span data-id="element-206">Tarjetas + Kit PRO</span>
                  <span className="font-bold" data-id="element-207">+ $6.000</span>
                </div>}
              <div className="border-t border-slate-200 mt-2 pt-2 flex justify-between items-center" data-id="element-208">
                <span className="font-bold text-slate-800" data-id="element-209">Total</span>
                <span className="text-xl font-black text-[#4a6fa5]" data-id="element-210">
                  {getEsencialTotal()}
                </span>
              </div>
            </div>

            {/* Buy button */}
            <a href={getEsencialCheckoutUrl()} className="block w-full bg-[#4a6fa5] hover:bg-[#3d5d8a] text-white text-center font-black text-base py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200" data-id="element-211">
              {esencialUpgrade || esencialAddOn ? '👉 Comprar con mejoras' : '👉 Continuar con el Plan Esencial'}
            </a>
          </div>
        </div>}

      {/* ===== COMPLETO UPSELL POPUP ===== */}
      {showCompletoUpsell && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-212">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowCompletoUpsell(false)} data-id="element-213"></div>
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 md:p-8 z-10" data-id="element-214">
            <button onClick={() => setShowCompletoUpsell(false)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-215">
              <X className="w-5 h-5" data-id="element-216" />
            </button>

            <div className="text-center mb-6" data-id="element-217">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-100 rounded-full mb-3" data-id="element-218">
                <Gift className="w-6 h-6 text-amber-600" data-id="element-219" />
              </div>
              <h3 className="text-xl font-black text-slate-800 mb-1" data-id="element-220">
                ¡Potenciá tu Sistema PRO!
              </h3>
              <p className="text-sm text-slate-500" data-id="element-221">
                Agregá estos recursos extra a tu compra
              </p>
            </div>

            <button onClick={() => setCompletoAddOn(!completoAddOn)} className={`w-full text-left rounded-xl p-4 border-2 transition-all duration-200 mb-6 ${completoAddOn ? 'border-amber-500 bg-amber-50 shadow-md' : 'border-slate-200 bg-slate-50 hover:border-slate-300'}`} data-id="element-222">
              <div className="flex items-start gap-3" data-id="element-223">
                <CheckboxIcon checked={completoAddOn} data-id="element-224" />
                <div className="flex-grow" data-id="element-225">
                  <p className="font-bold text-slate-800 text-sm mb-1" data-id="element-226">
                    📋 Tarjetas de Cuidados para Pacientes + 💰 Kit de Precios y
                    Paquetes PRO
                  </p>
                  <p className="text-xs text-slate-500 mb-2" data-id="element-227">
                    Material imprimible para pacientes y plantillas de precios
                    para tu consultorio.
                  </p>
                  <p className="text-lg font-black text-amber-600" data-id="element-228">
                    + $6.000{' '}
                    <span className="text-xs font-medium text-slate-400" data-id="element-229">
                      ARS
                    </span>
                  </p>
                </div>
              </div>
            </button>

            <div className="bg-slate-50 rounded-xl p-4 mb-6" data-id="element-230">
              <div className="flex justify-between items-center text-sm text-slate-600 mb-1" data-id="element-231">
                <span data-id="element-232">Sistema Completo</span>
                <span className="font-bold" data-id="element-233">$23.990</span>
              </div>
              {completoAddOn && <div className="flex justify-between items-center text-sm text-amber-600 mb-1" data-id="element-234">
                  <span data-id="element-235">Tarjetas + Kit PRO</span>
                  <span className="font-bold" data-id="element-236">+ $6.000</span>
                </div>}
              <div className="border-t border-slate-200 mt-2 pt-2 flex justify-between items-center" data-id="element-237">
                <span className="font-bold text-slate-800" data-id="element-238">Total</span>
                <span className="text-xl font-black text-[#4a6fa5]" data-id="element-239">
                  {completoAddOn ? '$29.990' : '$23.990'}
                </span>
              </div>
            </div>

            <a href={completoCheckoutUrl} className="block w-full bg-[#4a6fa5] hover:bg-[#3d5d8a] text-white text-center font-black text-base py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200" data-id="element-240">
              {completoAddOn ? '👉 Comprar con extras' : '👉 Continuar sin extras'}
            </a>

            {!completoAddOn ? <button onClick={() => setCompletoAddOn(true)} className="block w-full text-center text-sm text-amber-600 font-medium mt-3 hover:underline" data-id="element-241">
                Sí, quiero agregar los extras por $6.000
              </button> : <button onClick={() => setCompletoAddOn(false)} className="block w-full text-center text-sm text-slate-400 font-medium mt-3 hover:underline" data-id="element-242">
                No, gracias, continuar sin extras
              </button>}
          </div>
        </div>}
    </section>;
}